import { makeStyles } from '@mui/styles';
import React from 'react';
import { Box } from '@mui/material';

export default function ContentBox(prop) {
  const { children, backgroundColor, outerData, marginTop } = prop;

  const useStyles = makeStyles((theme) => ({
    inner: {
      position: 'relative',
      marginTop: !!marginTop ? marginTop : '106px',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      boxSizing: 'border-box',
      '@media only screen and (max-width: 1280px)': {
        padding: '0 32px',
      },
      '@media only screen and (max-width: 768px)': {
        marginTop: '32px',
      },

      overflow: 'hidden',
    },
    content: {
      width: '100%',
      maxWidth: '1280px',
    },
  }));

  const classes = useStyles();
  return (
    <Box className={classes.inner} style={{ backgroundColor: backgroundColor }}>
      {outerData}
      <Box className={classes.content}>{children}</Box>
    </Box>
  );
}
